import { apiBaseUrl } from "./config.api.baseUrl";

export const baseCountryIri = "/api/countries";

export const apiGetCountries = async (userToken: string) => {
    const response = await apiBaseUrl(userToken).get("/api/countries");
    return response.data;
};
